'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import V from "../defs/PresentationChart.js";
var n = Object.defineProperty, s = Object.defineProperties;
var f = Object.getOwnPropertyDescriptors;
var o = Object.getOwnPropertySymbols;
var p = Object.prototype.hasOwnProperty, c = Object.prototype.propertyIsEnumerable;
var a = (e, t, r) => t in e ? n(e, t, { enumerable: true, configurable: true, writable: true, value: r }) : e[t] = r, m = (e, t) => {
  for (var r in t || (t = {}))
    p.call(t, r) && a(e, r, t[r]);
  if (o)
    for (var r of o(t))
      c.call(t, r) && a(e, r, t[r]);
  return e;
}, i = (e, t) => s(e, f(t));
const C = forwardRef((e, t) => /* @__PURE__ */ a__default.createElement(b, i(m({ ref: t }, e), { weights: V })));
C.displayName = "PresentationChart";
export {
  C as PresentationChart
};
